import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'select',
    FormItemProps: {
      label: '下拉框',
      name: uuid,
    },
    options: [],
  }
};
